import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { FontNormal } from '@css/fonts'
import { fontSize } from '@css/styles'
import { black } from '@css/constants'

export const TRANSITION_DELAY = 300

export const PublicMobileMenuWrapper = styled('div')(css``)

export const ButtonContent = styled('div')(css`
  display: flex;
  align-items: center;
`)

export const IconWrapper = styled('span')(css`
  color: ${black};
`)

export const CloseIconWrapper = styled(IconWrapper)(css`
  & > svg {
    width: 20px;
    height: 20px;
  }
`)

export const HamburgerIconWrapper = styled(IconWrapper)(css`
  & > svg {
    width: 29px;
    height: 22px;
  }
`)

export const CloseText = styled('span')(css`
  ${FontNormal(400)};
  ${fontSize(16)};
  margin-right: 7px;
`)

export const FadeInWrapper = styled('div')<{ state: string }>(props => css`
  transition: opacity ${TRANSITION_DELAY}ms;
  opacity: ${getFadeOpacity(props.state)};
`)

const getFadeOpacity = (state: string): number => {
  switch (state) {
    case 'entering':
      return 1
    case 'exiting':
      return 0
    case 'exited':
      return 0
    case 'entered':
      return 1
    default:
      return 0
  }
}
